import typography from "assets/theme/base/typography";
import borders from "assets/theme/base/borders";
import colors from "assets/theme/base/colors";

import pxToRem from "assets/theme/functions/pxToRem";

const { size } = typography;
const { text } = colors;
const { borderWidth, borderColor } = borders;

const dialogContent = {
  styleOverrides: {
    root: {
      padding: pxToRem(16),
      fontSize: size.md,
      color: text.main,
      // Companion to MuiDialog.paper flex-column: make DialogContent the
      // scrollable region so DialogTitle + DialogActions stay pinned and
      // the middle scrolls when content exceeds the capped Paper height.
      // minHeight:0 is the flex-box trick — without it, flex children
      // refuse to shrink below their intrinsic height.
      flex: "1 1 auto",
      minHeight: 0,
      overflowY: "auto",
    },

    dividers: {
      borderTop: `${borderWidth[1]} solid ${borderColor}`,
      borderBottom: `${borderWidth[1]} solid ${borderColor}`,
    },
  },
};

export default dialogContent;
